/** Биллинг по сделке — ровно то, что отдаёт `GET /api/deals/{id}/billing`. */
import { apiFetch } from "@/lib/api";

/** Проводка `sBilling_expen_detail`: начисление (+) или списание (−). */
export type BillingRow = {
  id: number;
  at: string;
  amount: number;
  user_id: number;
  /** Полное имя `sUser.name`. */
  user: string | null;
  /** Город сотрудника: `sPlace_locationID.locationShort` («НН», «КЦ»). */
  user_loc: string | null;
  module_id: number;
  module: string;
  /** У корректировки — категория откатываемой проводки. */
  category_id: number | null;
  category: string;
  task_id: number | null;
  serial: number | null;
  product: string | null;
  bonus_deal_id: number | null;
  correct_of: number | null;
  comment: string | null;
};

/** Задача перемещения `sMove_task` сделки — с начислениями или без. */
export type BillingTask = {
  id: number;
  serial: number;
  product: string | null;
  group: string | null;
  type: string | null;
  status: string | null;
  done: boolean;
  cancel: boolean;
  user_id: number | null;
  user: string | null;
  user_loc: string | null;
  created: string | null;
  done_at: string | null;
  timer_min: number | null;
  comment: string | null;
  billing_sum: number | null;
  net: number;
  /** `billingSum` задачи ≠ CEIL суммы её проводок. */
  mismatch: boolean;
  billing: number[];
};

export type DealBilling = {
  deal_id: number;
  total: { net: number; accrued: number; written_off: number; users: number; tasks: number };
  rows: BillingRow[];
  tasks: BillingTask[];
};

export function loadDealBilling(id: number): Promise<DealBilling> {
  return apiFetch<DealBilling>(`/api/deals/${id}/billing`);
}
